import Input from '../../../../Core/Fields/Floating/Input';
import Date from '../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';

const AdditionalDiscount = ({ formData, onFieldChange, extraData }) => {

    return (
     
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Additional Discount</p>
                                    </div>
                                </div>
                                    
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                    <Input label="Apply Additional Discount On" style={{ height: "30px" }} value='' />
                                </div>
                                <div style={{ flex: 1 }}>
                                <label style={{height:'19px'}}></label>
                                     <Checkbox
                                            id="IsSubcontracted"
                                            label="Is Cash or Non Trade Discount"
                                        />
                                </div>
                               
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                    <Input label="Additional Discount Percentage" style={{ height: "30px" }} value='' />
                                </div>
                                <div style={{ flex: 1 }}>
                                
                                    <Input label="Additional Discount Amount (INR)" style={{ height: "30px" }} value='' />
                                </div>
                                
                            </div>
                        </div>
              

    );
};

export default AdditionalDiscount;